import { render, staticRenderFns } from "./cart-confirm.vue?vue&type=template&id=5f6471b6&scoped=true&"
import script from "./cart-confirm.vue?vue&type=script&lang=js&"
export * from "./cart-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6471b6",
  null
  
)

export default component.exports